import React, { useEffect, useMemo, useRef, useState } from "react";
import { addMonths, addYears, format, startOfYear, subDays } from "date-fns";
import "./CustomStyle.css";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedTimeData } from "./store";
import CustomHookForRuralDetailsCount from "../../ruralDetailsCount/CustomHookForRuralDetails";
import { setDisabled } from "../districtDetailsFilter/store";
import Button from "../../Form/FormFields/ButtonField";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { RootState } from "../../../utils/store";
type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];
function TimeOverview({ ...props }) {
  const [activeTab, setActiveTab] = useState("Today");
  const [isCustom, setIsCustom] = useState(false);
  const [isMonth, setIsMonth] = useState(false);
  const [isYear, setIsYear] = useState(false);
  // const [isSecondaryFilter, setIsSecondaryFilter] = useState(false);
  const from_date = useSelector((state) => state?.time?.time_data?.from_date);
  const to_date = useSelector((state) => state?.time?.time_data?.to_date);

  const selectorData = useSelector((state) => state);

  const componentData = selectorData?.chartListDetails?.componentData?.ALL;

  const isSecondaryFilter = useMemo(() => {
    if (!componentData) return false;

    return Object.values(componentData).some(
      (item: any) => item.chart_type_id === 7
    );
  }, [componentData]);

  const dateFilter =
    selectorData?.chartListDetails?.chart_list_data?.date_filter;

  const tillyesterday = {
    fromDate: "2014-01-01",
    toDate: subDays(new Date(), 1),
    type: "Till Yesterday",
  };

  const custom = {
    fromDate: startOfYear(new Date()),
    toDate: new Date(),
    type: "Custom",
  };
  //i want a yesterday date
  const { ruralDetailsCount } = CustomHookForRuralDetailsCount();
  const dispatch = useDispatch();
  const [showCalendar, setShowCalendar] = useState({ from: false, to: false });
  const calendarRef = useRef<HTMLDivElement>(null);
  const [value, onChange] = useState<Value>(new Date());
  const [selectedYear, setSelectedYear] = useState<number>(
    new Date().getFullYear()
  );
  const subFilterData = useSelector((state: RootState) => state.district);
  const timeDuration = async (data: any, initial: string) => {
    await dispatch(
      setSelectedTimeData({
        from_date: format(new Date(data?.fromDate), "yyyy-MM-dd"),
        to_date: format(new Date(data?.toDate), "yyyy-MM-dd"),
      })
    );
    setIsCustom(data?.type == "Custom" ? true : false);
    setIsMonth(data?.type == "Month" ? true : false);
    setIsYear(data?.type == "Year" ? true : false);
    setActiveTab(data?.type);

    if (["Till Yesterday", "Fortnight", "Week"].includes(data?.type)) {
      handleSubmit();
    }

    if (initial === "initial") {
      handleSubmit();
    }
  };

  useEffect(() => {
    if (dateFilter == "CY") {
      timeDuration(custom, "initial");
    } else {
      timeDuration(tillyesterday);
    }

    // timeDuration(custom, "initial");
  }, []);

  const timeDurationData = [
    tillyesterday,

    {
      fromDate: subDays(new Date(), 7),
      toDate: subDays(new Date(), 1),
      type: "Week",
    },
    {
      fromDate: subDays(new Date(), 15),
      toDate: subDays(new Date(), 1),
      type: "Fortnight",
    },
    {
      fromDate: addMonths(new Date(), -1),
      toDate: subDays(new Date(), 1),
      type: "Month",
    },
    {
      fromDate: "2024-01-01",
      toDate: "2025-01-01",
      type: "Year",
    },
    custom,
  ];

  const handleSubmit = async () => {
    // props?.renderAbleId?.date_filterable;
    dispatch(setDisabled(true));

    await Promise.all(
      props?.renderAbleId?.date_filterable.map((id: any) =>
        ruralDetailsCount(id, props)
      )
    );
    dispatch(setDisabled(false));
  };

  const handleReset = async () => {
    // await dispatch(
    //   setSelectedTimeData({
    //     from_date: "2024-01-01",
    //     to_date: "2024-02-02",
    //   })
    // );
    timeDuration(tillyesterday);

    setActiveTab(dateFilter == "CY" ? "Custom" : "Till Yesterday");
    handleSubmit();
  };

  const handleFromChange = async (date: Value) => {
    if (!date || Array.isArray(date)) return; // Only handle single date selection
    await dispatch(
      setSelectedTimeData({
        from_date: format(new Date(date), "yyyy-MM-dd"),
        to_date: to_date,
      })
    );
    setShowCalendar({ from: false }); // Auto-hide
  };

  const handleToChange = async (date: Value) => {
    if (!date || Array.isArray(date)) return; // Only handle single date selection
    const year = date.getFullYear();

    if (isMonth) {
      const month = date.getMonth();
      const lastDate = new Date(year, month + 1, 0);
      const formatedDate = await format(new Date(lastDate), "yyyy-MM-dd");
      // Get last date of selected month
      await dispatch(
        setSelectedTimeData({
          from_date,
          to_date: formatedDate,
        })
      );
    } else if (isYear) {
      const lastDateOfYear = new Date(year, 11, 31);
      const formatedDate = await format(new Date(lastDateOfYear), "yyyy-MM-dd");
      await dispatch(
        setSelectedTimeData({
          from_date,
          to_date: formatedDate,
        })
      );
    } else {
      await dispatch(
        setSelectedTimeData({
          from_date,
          to_date: format(new Date(date), "yyyy-MM-dd"), // use existing to_date
        })
      );
    }

    setShowCalendar({ to: false }); // Auto-hide
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        calendarRef.current &&
        !(calendarRef.current as HTMLElement).contains(event.target as Node)
      ) {
        // Hide both calendars if click happens outside
        setShowCalendar({ from: false, to: false });
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [calendarView, setCalendarView] = useState<"month" | "year" | "decade">(
    "month"
  );

  return (
    <div>
      <div className="flex items-center space-x-4 p-1">
        {/* Tab Section */}
        {/* <div className="flex border border-[#487FFF] rounded-lg overflow-hidden"> */}
        <div className="flex overflow-hidden">
          {timeDurationData?.map((item, i) => (
            <button
              key={i}
              className={`text-sm px-6 py-[10px] ${
                activeTab === item.type
                  ? "bg-[#487FFF] text-white"
                  : "bg-white text-[#959CB6]"
              } transition cursor-pointer`}
              onClick={() => {
                // if (item.type == "Month") {
                //   setShowCalendar({ from: true })
                //     setShowCalendar({ to: true })
                // }

                timeDuration(item);
              }}
            >
              {item.type}
            </button>
          ))}
        </div>

        {/* Date Picker Section */}

        <div className="flex space-x-1.5">
          <p
            onClick={() =>
              (isCustom || isMonth || isYear) && setShowCalendar({ from: true })
            }
            className="px-4 py-2 bg-green-500 text-white rounded-md shadow-md hover:bg-green-600"
          >
            {from_date?.split("-").reverse().join("-")}
          </p>
          <div className="">
            {showCalendar?.from && (
              <div
                ref={calendarRef}
                className="absolute z-50 mt-2 border border-gray-300 rounded-md shadow-lg bg-white"
              >
                {/* <div className="p-2 border-b border-gray-200">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Select Year
                  </label>
                  <select
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(Number(e.target.value))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                  >
                    {Array.from(
                      { length: new Date().getFullYear() - 2000 },
                      (_, i) => 2001 + i
                    ).map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div> */}
                <Calendar
                  view={isMonth ? "year" : isYear ? "decade" : "month"}
                  maxDetail={isMonth ? "year" : isYear ? "decade" : "month"}
                  onChange={handleFromChange}
                  value={value}
                  className="p-2"
                  maxDate={new Date()}
                  // activeStartDate={new Date(selectedYear, 0, 1)}
                />
              </div>
            )}
          </div>
          <div>
            <p
              onClick={() =>
                (isCustom || isMonth || isYear) && setShowCalendar({ to: true })
              }
              className="px-4 py-2 bg-green-500 text-white rounded-md shadow-md hover:bg-green-600"
            >
              {to_date && to_date?.split("-")?.reverse()?.join("-")}
            </p>
            <div className="">
              {showCalendar?.to && (
                <div
                  ref={calendarRef}
                  className="absolute z-50 mt-2 border border-gray-300 rounded-md shadow-lg bg-white cursor-pointer"
                >
                  {/* <div className="p-2 border-b border-gray-200">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Select Year
                    </label>
                    <select
                      value={selectedYear}
                      onChange={(e) => setSelectedYear(Number(e.target.value))}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                    >
                      {Array.from(
                        { length: new Date().getFullYear() - 2000 },
                        (_, i) => 2001 + i
                      ).map((year) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                  </div> */}
                  <Calendar
                    view={isMonth ? "year" : isYear ? "decade" : "month"}
                    maxDetail={isMonth ? "year" : isYear ? "decade" : "month"}
                    onChange={handleToChange}
                    value={value}
                    className="p-2"
                    maxDate={new Date()}
                    // activeStartDate={
                    //   selectedYear ? new Date(selectedYear, 0, 1) : new Date()
                    // }
                    // onDrillDown={({ activeStartDate, view }) =>
                    //   setCalendarView(view)
                    // }
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        {(isCustom || isMonth || isYear) && !isSecondaryFilter ? (
          <>
            <Button
              name="Apply"
              // className="p-2 rounded-md  text-[#487FFF]"
              onClick={handleSubmit}
              // disabled={selectorData?.district?.disabled}
              className={`btn ${
                selectorData?.district?.disabled ? "disabled-btn" : "apply-btn"
              } `}
            />
            <Button
              // className="p-2 rounded-md  text-[#487FFF]"
              onClick={handleReset}
              disabled={selectorData?.district?.disabled}
              className={`btn ${
                selectorData?.district?.disabled ? "disabled-btn" : "reset-btn"
              } `}
              name="Reset"
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}

export default TimeOverview;
